// Sample prices and syllabus: change these to your actual course details.
const topics = [
  {
    id: "multi",
    title: "Multi Embroidery Design",
    description:
      "Learn to create embroidery designs using different stitches and colors. Practise small designs, borders and filled shapes. Understand how to arrange the stitching order and check your design before it is used on a machine.",
    topics: [
      "Choose a picture and set up your design",
      "Learn running, satin and fill stitches",
      "Arrange colors and check the finished design",
    ],
  },
  {
    id: "cording",
    title: "Cording Embroidery",
    description:
      "Learn to make designs with cord outlines and patterns. Practise straight lines, smooth curves and borders. Understand spacing and stitching order, and learn to check the design before it is used on a machine.",
    topics: [
      "Learn the basic cording tools",
      "Draw smooth lines, curves and corners",
      "Check the design and review a sample",
    ],
  },
  {
    id: "chain",
    title: "Chain Stitch Design",
    description:
      "Learn to create chain stitch designs step by step. Practise lines, repeated patterns and borders. Understand how to connect parts of a design and arrange the stitching order for a neat finish.",
    topics: [
      "Learn the basics of chain stitch",
      "Create borders and repeating patterns",
      "Arrange the stitch order and check a sample",
    ],
  },
  {
    id: "sequin",
    title: "Sequin Embroidery",
    description:
      "Learn to create embroidery designs with sequins. Practise placing sequins, keeping even gaps and making repeated patterns. Learn how to combine sequins with stitches and check the finished design.",
    topics: [
      "Learn how to place sequins",
      "Set spacing and repeat a pattern",
      "Practise designs with sequins and stitches",
    ],
  },
  {
    id: "beads",
    title: "Beads Embroidery",
    description:
      "Learn to create embroidery designs with beads. Practise bead placement, spacing and simple patterns. Explore small designs and borders, and learn how to review your work before machine stitching.",
    topics: [
      "Place beads and set the spacing",
      "Create small patterns and borders",
      "Check your practice design",
    ],
  },
];
export const courses = topics.flatMap((topic) => [
  {
    ...topic,
    description: topic.description,
    id: `${topic.id}-demo`,
    category: topic.id,
    type: "demo",
    title: `${topic.title} — Free Demo`,
    image: `/images/embroidery/${topic.id}.webp`,
    price: 0,
    duration: "Free introduction class",
    buyUrl: "",
  },
  {
    ...topic,
    description: topic.description,
    id: `${topic.id}-paid`,
    category: topic.id,
    type: "paid",
    title: `${topic.title} — Complete Course`,
    image: `/images/embroidery/${topic.id}.webp`,
    price: {
      multi: 2500,
      cording: 3500,
      chain: 3000,
      sequin: 4000,
      beads: 4500,
    }[topic.id],
    duration: "Contact us for class timings",
    buyUrl: "",
  },
]);

export const formatPrice = (price) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(price);
export const getPurchaseUrl = () =>
  "https://www.embroiderydesigncourse.com/courses/";
export const getCourseVideos = (course) =>
  course.topics.map((title, index) => ({
    id: `${course.id}-${index + 1}`,
    title,
    step: index + 1,
    thumbnail: course.image,
  }));
